import * as React from 'react';
import clsx from 'clsx';

interface Props {
  children?: React.ReactNode;
  hint?: string | JSX.Element | null;
  error?: string;
  label?: React.ReactChild;
  largeLabel?: boolean;
  modifierClassName?: string;
  showRequiredLegend?: boolean;
  warn?: string;
}

/**
 * @deprecated
 * Use Grid to layout your forms.
 */
export default class Fields extends React.PureComponent<Props> {
  render() {
    const {
      children,
      error,
      hint,
      label,
      largeLabel,
      modifierClassName,
      showRequiredLegend,
      warn,
    } = this.props;

    const className = clsx('Fields', modifierClassName);

    return (
      <div className={className}>
        {label && (
          <div className={clsx('Label', 'Label--fields', { Large: largeLabel })}>
            {label}
            {showRequiredLegend && <span className="Label-required">(* Required)</span>}
          </div>
        )}

        {children}

        {error && (
          <div className="Errors" key="Errors">
            <div className="Error" aria-live="polite">
              {error}
            </div>
          </div>
        )}

        {hint && (
          <div className="Hints Hints--fields">
            <div className="Hint">{hint}</div>
          </div>
        )}

        {warn && (
          <div className="NewWarnings">
            <div className="NewWarning">{warn}</div>
          </div>
        )}
      </div>
    );
  }
}
